import type { PopupWarningTypes } from 'editor/src/store/design/operation/requestDesignDataOperation';
import { WarningLevel, WarningType } from 'editor/src/store/editorModules/warnings/types';

/**
 * Warnings that stop the header "Continue" until the buyer confirms. A charged print area left
 * empty is a cheaper purchase, not a mistake (the pricing session already refuses a design that
 * fills none), so an empty page only counts without area pricing. An empty image box sits inside an
 * area the buyer did start, so it stays a mistake either way.
 */
function getContinueWarningChecks(pricingActive: boolean): PopupWarningTypes {
  const emptyAreaWarnings = pricingActive ? [] : [{ type: WarningType.EmptyPage, level: [WarningLevel.Medium] }];
  return [
    ...emptyAreaWarnings,
    { type: WarningType.EmptyDesign, level: [WarningLevel.Medium] },
    { type: WarningType.EmptyImageBox, level: [WarningLevel.Medium] },
    { type: WarningType.LowDPI, level: [WarningLevel.High] },
    { type: WarningType.SampleElementNotReplaced, level: [WarningLevel.High] },
    { type: WarningType.NotVisible, level: [WarningLevel.Medium] },
    { type: WarningType.OutOfRange, level: [WarningLevel.Medium] },
    { type: WarningType.DtfImageBackground, level: [WarningLevel.Low] },
    // Lines that do not fit a fixed text frame still print, below it.
    { type: WarningType.TextOverflow, level: [WarningLevel.Medium] },
  ];
}

export default getContinueWarningChecks;
